// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message_2gLMfSuUSMHWuCBpDsR2AE","spin":"styles_spin_1a0KsJ4ofKdJEZWGZC5sG"};